export const CHART_TOUR_ID = 'patient-chart'

export const CHART_ONBOARDING_STEPS = [
  {
    title: 'Este é o prontuário',
    body: 'Tudo do plantão deste paciente fica aqui. Os botões redondos da direita são atalhos: você anota, oferece água e afere sem caçar a aba certa.',
  },
  {
    target: '[data-onboarding="chart-shift"]',
    title: 'Plantão',
    body: 'Comece o plantão neste paciente antes de registrar. Enquanto ele estiver aberto, sinais, água e notas ficam ligados a este prontuário.',
  },
  {
    target: '[data-onboarding="chart-profile"]',
    title: 'Quem é o paciente',
    body: 'Foto, leito, convênio e médico ficam sempre à vista. Confira o nome antes de lançar qualquer coisa.',
  },
  {
    target: '[data-onboarding="chart-alerts"]',
    title: 'Alergias e alertas',
    body: 'O cartão vermelho é alergia. O âmbar é alerta clínico. Olhe os dois antes de medicar ou oferecer alimento.',
  },
  {
    target: '[data-onboarding="chart-actions"]',
    title: 'Ações do prontuário',
    body: 'Aferir, medicar e evoluir ficam nestes botões. Use o que o plantão pedir, sem abrir aba por aba.',
  },
  {
    target: '[data-onboarding="chart-evolution"]',
    title: 'Evolução do dia',
    body: 'No fim do turno, abra a evolução. As notas que você escreveu no plantão entram no subjetivo com um clique, prontas para revisar.',
  },
  {
    target: '[data-onboarding="chart-tabs"]',
    title: 'As abas do cuidado',
    body: 'Sinais, medicamentos, alimentação, diário e o restante moram aqui. O que você lança num atalho aparece na aba correspondente.',
  },
  {
    target: '[data-onboarding="chart-vitals"]',
    title: 'Os números de agora',
    body: 'Peso, altura e os últimos sinais ficam nestes cartões. Só aparece o que alguém mediu de verdade.',
  },
  {
    target: '[data-onboarding="chart-measure"]',
    title: 'Peso, altura e nova medição',
    body: 'Os ícones registram peso e altura. Nova medição abre a aferição: pode ser só a temperatura ou só a frequência. A pressão pede sistólica e diastólica juntas.',
  },
  {
    target: '[data-onboarding="chart-fab-vitals"]',
    title: 'Atalho de sinais',
    body: 'Este botão abre a aferição de qualquer lugar do prontuário. Meça o que mudou agora e deixe o resto em branco.',
  },
  {
    target: '[data-onboarding="chart-fab-water"]',
    title: 'Água livre',
    body: 'Ofereceu água? Toque aqui e lance o volume na hora. O total do dia aparece na aba Alimentação.',
  },
  {
    target: '[data-onboarding="chart-fab-notes"]',
    title: 'Nota do plantão',
    body: 'Aconteceu algo no plantão? Clica aqui e anote na hora. No final do dia, você importa tudo direto para a sua evolução em um clique. Sem estresse e sem esquecer nenhum detalhe!',
  },
]
